// extracted by mini-css-extract-plugin
export default {"heading":"RegionTrainingPlansPage_heading__pjCKY","pagination":"RegionTrainingPlansPage_pagination__y7WiG","headingContainer":"RegionTrainingPlansPage_headingContainer__wIag7"};